module.exports = __webpack_public_path__ + "img/220px-Logo_App_Store_d'Apple.0c792515.png";